var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOsnovyStretchinga(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 42.692,
    height: 42.688,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 3.98 3.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fil11,.fil2,.fil3{fill:#8c4cd1;fill-rule:nonzero}.fil2,.fil3{fill:#f4958c}.fil2{fill:#ffaea1}"))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2273311518096"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.99,
    cy: 1.99,
    r: 1.99,
    style: {
      fill: "#303a59",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.99,
    cy: 1.99,
    r: 1.36,
    style: {
      fill: "#3e4a68",
      fillRule: "nonzero"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.07.85h-.2v.2H.4c-.08 0-.41.01-.41.04s.17.03.19.04c.02.01.14.04.17.04.03-.01.07-.03.07-.03s.4.1.52.09h.48c.02 0 .05.09.08.2h.94c.03-.11.06-.2.08-.2H3c.12.01.52-.09.52-.09s.04.02.07.03c.03.01.15-.03.17-.04.02-.01.19-.01.19-.04s-1.81-.04-1.88-.04c-.01-.16-.02-.24-.03-.2z",
    className: "fil2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.55 1.32a.123.123 0 0 0-.11-.07c.02 0 .05.09.08.2h.08l-.05-.13zM1.88 1.05s.18 0 .2-.2h-.2v.2z",
    className: "fil3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.87.43c-.02.07.02.08-.01.15-.02.07-.07.05-.09.11-.02.07.02.08-.01.15v.01c-.03.07-.11.1-.18.07a.15.15 0 0 1-.09-.18V.73c.02-.07.07-.05.09-.11.02-.07-.02-.08.01-.15.02-.07.07-.05.09-.11l.18.07z",
    style: {
      fill: "#aa1e1e",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.28.57-.29.16-.3-.16S1.65.43 1.67.35c.02-.08.09-.09.09-.09s.02-.12.23-.12c.21 0 .38.14.28.43z",
    style: {
      fill: "#ff3345",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.68.36c-.02.08.02.22.02.22l.15.08.01-.01V.44C1.81.4 1.75.33 1.77.28c0 0-.07.01-.09.09z",
    style: {
      fill: "#e32828",
      fillRule: "nonzero"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.77.62S1.74.55 1.69.57c-.05.02 0 .16.1.17L1.77.62z",
    className: "fil3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.21.62s.03-.07.08-.05c.05.02 0 .16-.1.17l.02-.12z",
    className: "fil2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.21.54c0-.01-.01-.02-.01-.03L1.98.45l-.22.06c0 .01 0 .02-.01.03-.01.03-.03.04-.03.04v.01c0 .19.11.41.25.41s.25-.22.25-.41V.58S2.2.57 2.19.54z",
    style: {
      fill: "#ffcfc2",
      fillRule: "nonzero"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.82.59c0-.03 0-.07.01-.1l-.06.02c0 .01 0 .02-.01.03-.01.03-.03.04-.03.04v.01c0 .19.11.41.25.41.01 0 .03 0 .04-.01-.12-.04-.21-.23-.21-.4z",
    className: "fil2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.99.41c-.09 0-.12-.03-.15-.03h-.02c-.03.01-.04.08-.04.12h.43C2.2.46 2.2.39 2.17.38h-.02c-.03 0-.07.03-.15.03z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.94.46c0-.03.02-.05.05-.05-.09 0-.12-.03-.15-.03h-.02c-.03.01-.04.08-.04.12H2c-.03 0-.05-.02-.05-.05z",
    style: {
      fill: "#ebf0f3",
      fillRule: "nonzero"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M.74 3.77s.03.13 0 .18c-.03.04-.13.03-.18.01-.05-.02-.17.02-.27.02s-.17 0-.17-.04c0-.05.41-.21.41-.21l.21.05zM3.65 3.7s.04.02.04.05c.01.03 0 .17.03.2.01.02.06.02.11.03.05 0 .1-.04.1-.09 0-.02-.01-.04-.02-.06a.127.127 0 0 1-.04-.09c-.01-.06-.09-.1-.13-.15l-.09.11z",
    className: "fil3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.52 2.28s-.73.04-.88.16C.5 2.56.65 3.53.53 3.73c0 0 .06.08.21.05 0 0 .19-.77.19-.87 0-.1-.04-.23-.04-.23s.38.12.74.06c.35-.05.65.11.85.26.2.15.35.22.43.25.07.03.19.18.29.24.11.05.45.23.45.23s.08-.04.09-.11c0 0-.44-.42-.56-.5-.12-.07-.22-.13-.31-.22-.1-.09-.28-.45-.41-.6l-.49-.18-.45.18z",
    style: {
      fill: "#9c68e1",
      fillRule: "nonzero"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M.74 3.25c-.08 0-.15-.06-.16-.13 0 .26.01.52-.05.61 0 0 .06.08.21.05 0 0 .09-.36.14-.62-.02.06-.08.1-.15.1zM3.33 3.42a.15.15 0 0 1-.17.03c.01.01.03.02.04.03.11.05.45.23.45.23s.08-.04.09-.11c0 0-.22-.22-.39-.37.04.06.04.14-.02.19z",
    className: "fil11"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.38 1.93a.544.544 0 0 1 0-.18c.02-.08.05-.21.08-.31a.47.47 0 0 1-.09-.36v-.02h-.14l-.02.12c-.01.06-.04.11-.09.14-.04.02-.08.03-.13.03-.04 0-.09-.01-.13-.03a.194.194 0 0 1-.09-.14l-.02-.12h-.14v.02c.02.13-.02.26-.09.36.03.11.06.23.08.31.01.06.01.12 0 .18l-.08.34s.11.19.47.19.47-.19.47-.19l-.08-.34z",
    style: {
      fill: "#ffe854",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.66 2.4.07-.49a.4.4 0 0 0-.02-.19c.1 0 .17-.05.17-.05-.11.02-.2-.03-.24-.12l-.08-.19c-.01.01-.01.03-.02.04 0 .01-.01.01-.01.02s-.01.01-.01.02c.01.02.05.17.05.17.01.03.01.06.02.09 0 .02.01.04.01.05 0 .01.01.03.01.04.01.04 0 .12-.01.13l-.08.34s.04.06.14.12z",
    style: {
      fill: "#ffcf11",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOsnovyStretchinga);
export default __webpack_public_path__ + "static/media/osnovy-stretchinga.6f019649ca19490d7fb844db81536936.svg";
export { ForwardRef as ReactComponent };